import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React, { Fragment, useContext, useEffect, useState } from "react";
import AuthContext from "../../services/firebase/auth-context/provider";
import FirebaseHandler from "../../services/firebase";
import AccountData from "./data";
import LoadingSpinner from "../common/loading-spinner";
import { httpsCallable } from "firebase/functions";
import { signOut, sendPasswordResetEmail } from "firebase/auth";
var AccountOverview = function AccountOverview() {
    var _customerData$actionU;
    var _useContext$ = useContext(AuthContext)[0], authenticated = _useContext$.authenticated, user = _useContext$.user, userClaims = _useContext$.userClaims;
    var _useState = useState(undefined), customerData = _useState[0], setCustomerData = _useState[1];
    var _useState2 = useState(null), errCode = _useState2[0], setErrCode = _useState2[1];
    var _useState3 = useState(null), notification = _useState3[0], setNotification = _useState3[1];
    useEffect(function () {
        var accountOverviewCall = httpsCallable(FirebaseHandler.functions, "accountOverview");
        accountOverviewCall().then(function (res) {
            return setCustomerData(res.data);
        }).catch(function (err) {
            setErrCode(err.message);
            console.error(err);
        });
    }, [authenticated]);
    var requestPasswordReset = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(auth) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(user && user.email)) {
                                _context.next = 13;
                                break;
                            }
                            _context.prev = 1;
                            _context.next = 4;
                            return sendPasswordResetEmail(auth, user.email);
                        case 4:
                            setNotification("Ein Link zum Zurücksetzen des Passworts wurde an Ihre E-Mail-Adresse gesendet.");
                            _context.next = 11;
                            break;
                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context["catch"](1);
                            console.error("Fehler beim Senden des Passwort-Zurücksetzungslinks:", _context.t0);
                            setNotification("Beim Senden des Passwort-Zurücksetzungslinks ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.");
                        case 11:
                            _context.next = 14;
                            break;
                        case 13:
                            alert("Sie müssen angemeldet sein, um das Passwort zurückzusetzen.");
                        case 14:
                            setTimeout(function () {
                                setErrCode(null);
                            }, 5000);
                        case 15:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, null, [[1, 7]]);
        }));
        return function requestPasswordReset(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap pt-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/2 md:flex md:flex-col md:justify-center"
    }, /*#__PURE__*/ React.createElement("div", null, "Sie sind als ", /*#__PURE__*/ React.createElement("strong", null, user.email), " angemeldet.")), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-start xl:items-end mt-3 md:w-1/2 md:flex md:justify-end md:mt-0"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return signOut(FirebaseHandler.auth);
        },
        className: "text-xl text-center text-white inline-block px-10 pt-1 bg-makroOrange hover:bg-gray-600"
    }, "ABMELDEN"), /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return requestPasswordReset(FirebaseHandler.auth);
        },
        className: "text-xl mt-4 text-center text-white inline-block px-10 pt-1 bg-makroOrange hover:bg-gray-600"
    }, "Passwort zur\xFCcksetzen"))), notification && /*#__PURE__*/ React.createElement("div", {
        className: "text-white p-4 mt-6 bg-makroOrange rounded"
    }, /*#__PURE__*/ React.createElement("p", null, notification)), customerData && errCode == null ? /*#__PURE__*/ React.createElement(AccountData, {
        customerData: customerData
    }) : errCode == null && !customerData ? /*#__PURE__*/ React.createElement(LoadingSpinner, null) : /*#__PURE__*/ React.createElement(ErrorMessage, {
        errCode: errCode
    }), customerData && /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap mt-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/2 md:pr-4 flex flex-col justify-center"
    }, /*#__PURE__*/ React.createElement("a", {
        href: customerData === null || customerData === void 0 ? void 0 : (_customerData$actionU = customerData.actionUrls) === null || _customerData$actionU === void 0 ? void 0 : _customerData$actionU.changeData,
        target: "_blank",
        className: "text-xl text-center text-white inline-block px-10 pt-1 bg-makroOrange hover:bg-gray-600"
    }, "DATEN \xC4NDERN")), /*#__PURE__*/ React.createElement("div", {
        className: "w-full mt-3 md:w-1/2 md:pl-4 md:mt-0"
    }, "Sie haben Fragen oder W\xFCnsche zu Ihrem Abonnement?", /*#__PURE__*/ React.createElement("br", null), " Schreiben Sie uns:", " ", /*#__PURE__*/ React.createElement("a", {
        href: "mailto:aboservice@makroskop.eu",
        className: "text-makroOrange"
    }, "aboservice@makroskop.eu"))));
};
var ErrorMessage = function ErrorMessage(_ref2) {
    var errCode = _ref2.errCode;
    var errorMessages = {
        "NO_CUSTOMER": "Um die Accountübersicht einzusehen, müssen Sie ein Abonnement besitzen."
    };
    var getErrorMessage = function getErrorMessage(code) {
        return errorMessages[code] || "Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "text-white p-4 mt-6 bg-makroOrange rounded"
    }, /*#__PURE__*/ React.createElement("p", null, getErrorMessage(errCode)));
};
export default AccountOverview;
